import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user';
import subaccounts from './modules/subaccounts';
import referrals from './modules/referrals';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    language: 'en',
  },
  modules: {
    subaccounts,
    referrals,
    user,
  },
  mutations: {
    switchLanguage(state, { lang }) {
      const st = state;
      if (lang === 'en' || lang === 'es') {
        st.language = lang;
      }
    },
  },
});

export default store;
